export default {
  headerPopup: 'bg-blue-50 p-2 text-xs flex items-center flex',
  flagType: 'text-lg flex-1',
  flagTypeName: 'w-full justify-between!',
  infoOutlinedIcon: 'bg-blue-50 p-2 text-xs flex items-center',
  infoOutlinedIconClass: 'text-#0070A2-700 mr-2 inline-block flex-0.2',
  iconSpacing: 'mr-[5px]!',
};
